<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("status", 2) }}
      </div>
      <router-link class="btn-blue" to="statuses"
        >{{ $tc("status", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Statuses"
          :key="index"
          v-if="item.fieldname !== 's_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div
            v-if="
              item.fieldname !== 's_is_active' &&
              item.fieldname !== 's_is_show_status' &&
              item.fieldname !== 's_is_booking_status'
            "
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 's_is_booking_status'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t(item.label) }}</label>
              <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.fieldvalue"
                />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
          <div v-if="item.fieldname === 's_is_show_status'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t(item.label) }}</label>

              <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.fieldvalue"
                />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
          <div v-if="item.fieldname === 's_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.fieldvalue"
                />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(false)"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button class="btn-black" @click.prevent.stop="onResetForm">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="statuses">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Statuses from "@/helper/formJSONMaster/Statuses";

export default {
  data() {
    return {
      btenable: false,
      Statuses: Statuses.ms_statuses,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Statuses.Methods,
    };
  },
  mounted() {
    this.onResetForm();
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    onResetForm: function () {
      this.Statuses.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;

          let body = this.getRequestBody("POST", this.Statuses, this.Methods);
          MasterService.GlobalRequest(body)
            .then((response) => {
              const { data } = response;
              this.btenable = false;
              if (data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/statuses",
                  });
                }
              } else {
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              this.btenable = false;
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/StatusesComponents/addStatus.vue